export { PadlockClosedIcon } from './padlock-closed'
